/**
 * cardGridCarousel
 */

// Module dependencies
import 'protons';

// Module styles
import './_scrolling-carousel.scss';

// Module template
import './_scrolling-carousel.twig';

export const name = 'scrollingCarousel';

export function disable() {}

export function enable() {}

export default enable;

/* eslint-disable */


/* eslint-disable */
$('.horizontal-scrolling').each(function(i,el){
  el.id = i+1;
});


/* eslint-disable */
function horizontalScrolling() {
  const elements = document.querySelectorAll('.scroll_sequence');
  console.log("elements length="+elements.length);
  if (elements.length === 0) return false;

  Array.prototype.forEach.call(elements, el => {
    const slideWidth = el.getBoundingClientRect().width;
    const children = el.querySelectorAll('.scroll-card');
    el.parentNode.style.height = `calc(100vh + ${(children.length - 1)*slideWidth}px)`;
    el.setAttribute('data-is-init', false);
  });

  setupObserver$1(elements);
}

function setupObserver$1(elements) {

  function observerCallbackFunction(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const { target } = entry;
        const isInit = target.getAttribute('data-is-init') === 'true';
        if (!isInit) {
          // setupScroll(target);
          target.setAttribute('data-is-init', 'true');
        }
      }
    });
  }
  const options = {
    rootMargin: `0px 0px -${window.innerHeight/2}px 0px`,
  };

  const observer = new IntersectionObserver(observerCallbackFunction, options);

  Array.prototype.forEach.call(elements, (el) => {
    observer.observe(el);
    setupScroll(el);
  });
}

function setupScroll(el) {
  const wrapper = el.querySelector('.scrolling_wrapper');
  const wrapperWidth = wrapper.scrollWidth;

  const slideWidth = el.getBoundingClientRect().width;
  console.log("slideWidth="+slideWidth);
  const parent = el.parentNode;
  const { top } = getPosition(parent);

  let ticking = false;

  window.addEventListener('scroll', scrollListener);

  function scrollListener(evt) {
    if (!ticking) {
      window.requestAnimationFrame((evt) => {
        ticking = false;
        const scroll = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
        let offset = scroll - top;
        offset = constrain(offset, 0, wrapperWidth - slideWidth);
        const wrapperID = jQuery(wrapper).parent().parent().attr('id');
        console.log("wrapperID-"+wrapperID);
        jQuery("#"+wrapperID+"> div > div.scrolling_wrapper").css({'transform' : `translate(${-offset}px, 0)`});

      });
    }
    ticking = true;
  }
}

function getPosition(el) {
  const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function constrain(n, low, high) {
  return Math.max(Math.min(n, high), low);
}
horizontalScrolling();
